export default __webpack_public_path__ + "static/media/FlatGenericSEFullSize.c1cd987f.png";